import { gql } from '@apollo/client';

export const ParagraphPoiPassProfileFragment = gql`
  fragment ParagraphPoiPassProfile on ParagraphPoiPassProfile {
    id
    title
  }
`;
